import React, {Component} from 'react'
import {Input, Label, Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'
import addClientMutation from '../../queries/server/mutations/add_project_client_mutation'

class ClientSearchListItem extends Component {

    static getDerivedStateFromProps(props, state) {
        state = props

        return state
    }

    toggleContact = (contact_id, selected) => {
        const {state: {client}} = this

        const updatedClient = {...client}

        updatedClient.client_contacts = updatedClient.client_contacts.map(contact => {
            if (contact_id === contact.contact_id) {
                contact.selected = selected
            }
            return contact
        })

        this.setState({client: updatedClient})
    }

    toggleAddress = (address_id, selected) => {
        const {state: {client}} = this

        const updatedClient = {...client}

        updatedClient.client_addresses = updatedClient.client_addresses.map(address => {
            if (address_id === address.address_id) {
                address.selected = selected
            }
            else{
                address.selected = false
            }
            return address
        })

        this.setState({client: updatedClient})
    }

    addClient = () => {
        if (this.props.onClientAdd) this.props.onClientAdd()
    }

    render() {

        const {state: {client}, props: {project_id}} = this

        return (
            <Mutation mutation={addClientMutation}>
                {(addClientMutationFunc, {loading}) => (
                    <div className="d-flex flex-row border-bottom mt-3 justify-content-between">
                        <div className="d-flex flex-column border-bottom">
                            <p className="font-weight-light m-0 p-0">
                                {client.name}
                            </p>
                            <div className="d-flex flex-row">
                                {
                                    client.client_contacts.map(contact => {
                                        return (<div
                                            key={contact.contact_id}
                                            className="d-flex border-left border-right align-items-center justify-content-around p-4">
                                            <Label>
                                                <Input
                                                    type="checkbox"
                                                    checked={contact.selected}
                                                    onChange={(evt) => this.toggleContact(contact.contact_id, evt.target.checked)}
                                                />
                                                {contact.first_name} {contact.last_name}
                                            </Label>

                                        </div>)
                                    })
                                }
                            </div>
                            <div className="d-flex flex-row">
                                {
                                    client.client_addresses.map(address => {
                                        return (<div
                                            key={address.address_id}
                                            className="d-flex border-left border-right align-items-center justify-content-around p-4">
                                            <Label>
                                                <Input
                                                    type="radio"
                                                    name="billing_address"
                                                    checked={address.selected}
                                                    onChange={(evt) => this.toggleAddress(address.address_id, evt.target.checked)}
                                                />
                                                {address.full_address}
                                            </Label>

                                        </div>)
                                    })
                                }
                            </div>
                        </div>
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <Mutation mutation={editProjectLocalMutation}>
                                {(editProjectLocalMutationFunc) => (
                                    <Button
                                        size="sm"
                                        color="success"
                                        disabled={loading}
                                        className="square-btn"
                                        onClick={() => {

                                        const {client_id, name, client_contacts, client_addresses} = client

                                        const address = client_addresses.find(a => a.selected)

                                        const newClient = {
                                            client: {
                                                client_id,
                                                name,
                                                client_contacts: client_contacts
                                                    .filter(contact => contact.selected)
                                                    .map(({contact_id}) => ({contact_id}))
                                            },
                                            address: {address_id: address.address_id}
                                        }


                                        addClientMutationFunc({
                                            variables: {
                                                project_id,
                                                data: [newClient]
                                            }
                                        })
                                            .then(({data}) => {
                                                editProjectLocalMutationFunc({variables: {data: data.upsertProjectClientBillingAddresses}})
                                                toast.success('Client Added', {autoClose: 2000})
                                                this.addClient()
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))


                                    }}>
                                        <FontAwesomeIcon color="#fff" icon="plus"/>
                                        {loading && 'Saving...'}
                                    </Button>
                                )}
                            </Mutation>
                        </div>
                    </div>
                )}

            </Mutation>
        )
    }


}

ClientSearchListItem.propTypes = {
    project_id: PropTypes.string.isRequired,
    client: PropTypes.object.isRequired,
    onClientAdd: PropTypes.func.isRequired
}

export default ClientSearchListItem